import React from "react";

import { gettext } from "../shared/utils/legacy";
import { availableReportsType } from "../shared/utils/cropr";
import ReportsOverviewCard, { ReportOverviewCardProps } from "./ReportOverviewCard";
import planetproof from "../images/reports/planet-proof.svg";
import excel from "../images/reports/excel.png";
import clm from "../images/reports/clm.png";
import edi from "../images/reports/edi.png";
import sensus from "../images/reports/sensus.png";
import stockConfirmation from "../images/reports/stockConfirmation.png";
import planetproofIcon from "../images/reports/description_icons/planet-proof.svg";
import balanceReportIcon from "../images/reports/description_icons/balance-report.svg";
import cropProtectionMonitorIcon from "../images/reports/description_icons/crop-protection-monitor.svg";
import fieldMapIcon from "../images/reports/description_icons/field-map.svg";
import operationOverviewIcon from "../images/reports/description_icons/operation-overview.svg";
import stockIcon from "../images/reports/description_icons/stock.svg";
import mps from "../images/reports/description_icons/mps.png";

export const imagesLookup: {
  [key in string]: string;
} = {
  planetproof: planetproof,
  excel: excel,
  clm: clm,
  edi: edi,
  sensus: sensus,
  stockConfirmation: stockConfirmation,
  planetproofIcon: planetproofIcon,
  balanceReportIcon: balanceReportIcon,
  cropProtectionMonitorIcon: cropProtectionMonitorIcon,
  fieldMapIcon: fieldMapIcon,
  operationOverviewIcon: operationOverviewIcon,
  stockIcon: stockIcon,
  mps: mps,
};

export const ReportLandingpage = ({
  availableReports,
}: {
  availableReports: availableReportsType;
}) => {
  const populairReports: ReportOverviewCardProps[] = React.useMemo(
    () =>
      [
        "#reports/records/pm_balance/",
        "#reports/records/pm_operations_planetproof/",
        "#reports/records/pm_operations/",
      ]
        .map((url) => {
          const parts = url.split("/");
          const report = availableReports[parts[1]]?.["reports"][parts[2]];
          return (
            report && {
              title: report.title,
              img:
                (report.img && imagesLookup[report.img]) ||
                (report.icon && imagesLookup[report.icon]),
              fit: (report.img ? "cover" : "contain") as "cover" | "contain", //asume img is big and icon not
              href: url,
              content: report?.description || "",
            }
          );
        })
        .filter((r) => r), //Remove empty values since not all reports may be available to the current user.
    [availableReports]
  );
  return (
    (populairReports && (
      <div className={"nutrient-reports nutrient-reports--container"}>
        <div className={"d-flex justify-content-center"}>
          <h2 className={"mt-3 mb-3"}>{gettext("Reports")}</h2>
        </div>
        <div className="row">
          {/* Show 3 most popular reports */}
          {populairReports.slice(0, 3).map((populairReport) => (
            <ReportsOverviewCard
              key={populairReport.title}
              title={populairReport.title}
              img={populairReport.img}
              href={populairReport.href}
              content={populairReport.content}
              fit={populairReport.fit}
            />
          ))}
        </div>
      </div>
    )) || <></>
  );
};
